const English = {
  "enter your email address": "Enter your email address",
  "login with a link": "Login with a link",
  "next": "Next",
  "ready": "Login",
  "send me a login link": "Send me a login link",
  "scan qrcode to login": "Scan QRcode to login",

  // Chat Widget
  "chat.greeting.default": "Hi! 👋 I'm here to help you order. What would you like today?",
  "chat.greeting.welcome_back": "Welcome back, {NAME}! 👋\n\nI can see you've ordered from here before. Would you like to:\n• Order something you've had before\n• Try something new\n• See what's popular",
  "chat.suggestions.show_menu": "Show me the menu",
  "chat.suggestions.recommend": "What do you recommend?",
  "chat.suggestions.cheap": "I want something cheap",
  "chat.suggestions.order_again": "Order {NAME} again",
  "chat.error.init_failed": "I had trouble starting. Please try again.",
  "chat.error.message_failed": "Something went wrong. Please try again.",

  // Chat Header
  "chat.header.title": "Order Assistant",
  "chat.header.close": "Close chat",

  // Chat Input
  "chat.input.placeholder": "Type your message...",
  "chat.input.voice": "Voice input",
  "chat.input.send": "Send message",
  "chat.input.voice_not_supported": "Voice input is not supported in your browser.",

  // Chat Bubble
  "chat.bubble.open": "Open chat",

  // Language Switcher
  "chat.language.switch": "Switch to Spanish",
  "chat.language.switch_to_english": "Switch to English"
}

export default English;
